module.exports = {"title":"GoGoVan - 隱私權政策","privacy_headline":"隱私權政策","meta":{}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/tw/setting/privacy/locale.json
// module id = 745
// module chunks = 0 1 2 3 4 5